import apiHttpRequest from "services/api-http-request";

const listPowermeterSensors = async () => {
  let sensors = [];

  try {
    sensors = await apiHttpRequest.get('/house/corridor/powermeter');
  } catch (e) {
    console.error(e);
  }

  return sensors;
}

const getPowermeterSensorDetail = async (sensorType, startTime, endTime) => {
  const params = {};

  if (startTime && startTime.length > 0) {
    params.start_time = startTime
  }

  if (endTime && endTime.length > 0) {
    params.end_time = endTime;
  }

  let detail = {};

  try {
    detail = await apiHttpRequest.get(`/house/corridor/powermeter/${sensorType}`, params);
  } catch (e) {
    console.error(e);
  }

  return detail
}

export default {
  listPowermeterSensors,
  getPowermeterSensorDetail
}